import {Component, inject, Input} from '@angular/core';
import {Button} from 'primeng/button';
import {MailboxConfiguratorFacade} from '../../../mailbox-configurator.facade';
import {OutboundFormComponent} from '../../shared/outbound-form.component';
import {FormGroup} from '@angular/forms';

@Component({
	selector: 'app-outbound-step',
	standalone: true,
	template: `
		<div class="w-full flex flex-column gap-4">
			<app-outbound-form [form]="form" />

			<div class="flex justify-content-between gap-2">
				<p-button (onClick)="facade.back()" severity="secondary">Indietro</p-button>
				<p-button (onClick)="facade.next()"
						  [disabled]="form.invalid"
						  variant="outlined"
						  severity="success">Avanti</p-button>
			</div>
		</div>
	`,
	imports: [
		Button,
		OutboundFormComponent
	],
	styles: ``
})
export class OutboundStepComponent {
	protected facade = inject(MailboxConfiguratorFacade)

	@Input({ required: true }) form!: FormGroup;
}
